"use client";

import { Input } from "@/components/ui/input";
import { useDebounce } from "@uidotdev/usehooks";
import { X } from "lucide-react";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import qs from "query-string";
import { useEffect, useState } from "react";

export default function SearchFilter() {
  const pathname = usePathname();
  const router = useRouter();
  const searchParams = useSearchParams();

  const [input, setInput] = useState(searchParams.get("query") || "");
  const debouncedValue = useDebounce(input, 200);

  const currentCategoryId = searchParams.get("categoryId");

  useEffect(() => {
    const newUrl = qs.stringifyUrl(
      {
        url: pathname,
        query: {
          categoryId: currentCategoryId,
          query: debouncedValue,
        },
      },
      { skipEmptyString: true, skipNull: true },
    );

    router.replace(newUrl, { scroll: false });
  }, [currentCategoryId, debouncedValue, pathname, router]);

  return (
    <div className="relative w-full p-1">
      <Input
        placeholder="Search a course"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        className="rounded-xl p-6 text-base"
      />
      {input && (
        <X
          size={14}
          className="absolute right-6 top-1/2 -translate-y-1/2 cursor-pointer"
          onClick={() => setInput("")}
        />
      )}
    </div>
  );
}
